import { FormHelperText, MenuItem, Select, TextField, Typography } from "@material-ui/core";
import { TemplateProps } from "../../journeys/journey/Interfaces";
import Header from "../../organisms/Header/Header";
import { Button, Cards, CustomIcon, MaskedTextField } from "ams-ui-reactkit";
import DynamicHtml from "../../molecules/DynamicHtml";
import "./MovingProtection.scss";
import { TitleBlock } from "../../atoms";
import { useRef, useState } from "react";
import { SignatureCard } from "../../molecules";
import { useContextSelector } from "@fluentui/react-context-selector";
import { StoreContext } from "../../context";
import { calculateBase64SignSize } from "../../utils/Utils";
import { navigate } from "@reach/router";
import { actionTypeConstants } from "../../utils";
import { useEffect } from 'react';
import moment from 'moment';

const MovingProtection: React.FC<TemplateProps> = (props: any) => {
    const dispatch: any = useContextSelector(StoreContext, store => store?.dispatch);
    const customerInfoState: any = useContextSelector(StoreContext, store => store?.appState?.customerInfo);
    const source = customerInfoState?.IsTab;

    // console.log("page source#######", source);

    const { templateProps } = props;
    // console.log("templateProps:", templateProps);
    const { title, subtitle, data } = templateProps;

    const [signDate, setSignDate] = useState(new Date());

    const [selectedNo, SetSelectedNo] = useState(customerInfoState?.FVPOption || 0);
    const [selectedValue, setSelectedValue] = useState(5000); // default
    const [currentTarrifRate, setCurrentTarrifRate] = useState(data[1]?.tariffRate); // default
    const [coverageCost, setCoverageCost] = useState((selectedValue / 1000) * currentTarrifRate); // default
    // console.log("tariffRate:", data[1]?.tariffRate);
    const [loading, setLoading] = useState(false);
    const signatures: any = customerInfoState?.Signatureurl?.[0];

    // console.log("signatures:", signatures)
    const validateSignatureBySize = (process.env.REACT_APP_VALIDATE_SIGN_BY_SIZE === "true") ? true : false;
    const validSignatureSize = 4000;

    const [invalidCustomerSignMessage, setInvalidCustomerSignMessage] = useState("");

    const [customerSign, setCustomerSign] = useState<any>(signatures?.getUrl || "");
    const customerSignRef = useRef<SignaturePad>(null);

    const signaturesDriver: any = customerInfoState?.DriverSignurl?.[0];
    const [driverSign, setDriverSign] = useState<any>(signaturesDriver?.getUrl || "");
    const [invalidDriverSignMessage, setInvalidDriverSignMessage] = useState("");
    const [signDriverCDate, setSignDriverCDate] = useState(new Date());
    const driverSignRef = useRef<SignaturePad>(null);
    //alert(customerInfoState?.CustomerSelected)
    //const minAmt = customerInfoState?.FVPOption != -1 ? customerInfoState?.CustomerSelected : data[1]?.weightDetuctible.actualWeight * data[1]?.weightDetuctible.rate;

    const [signCDate, setSignCDate] = useState(signatures?.getUrl ?
        `SIGNED ${moment(new Date(customerInfoState?.SignedDated)).format('MM/DD/YYYY HH:mm A')}` :
        customerSign ? `SIGNED ${moment(signDate).format('MM/DD/YYYY HH:mm A')}` : "")

    const [signCDriverDate, setSignCDriverDate] = useState(signatures?.getUrl ?
        `SIGNED ${moment(new Date(customerInfoState?.DriverSignedDated)).format('MM/DD/YYYY HH:mm A')}` :
        customerSign ? `SIGNED ${moment(signDriverCDate).format('MM/DD/YYYY HH:mm A')}` : "")
    // console.log("signCDate:", signCDate)
    // console.log("signCDate signDriverCDate:", signCDriverDate)

    const isNorthCarolinaMove = () => {
        return customerInfoState?.Address?.includes(", NC,") || customerInfoState?.Address?.trim().endsWith(", NC")
    }

    const getRoundedMinimumValue = (value: number) => {
        if (!isNorthCarolinaMove()) {
            return value;
        }
        return Math.ceil(value / 100) * 100;
    }

    const getMinOwnDeclaredAmt = () => {
        let minAmt = 0;
        minAmt = data[1]?.weightDetuctible.actualWeight * data[1]?.weightDetuctible.rate;
        if (customerInfoState?.FVPOption != -1 && customerInfoState?.FVPOption == 1) {
            const custSelectedAmt = customerInfoState?.CustomerSelected;
            if (minAmt < custSelectedAmt) {
                // console.log(customerInfoState?.FVPOption, minAmt)
                return minAmt
            } else {
                // console.log(customerInfoState?.FVPOption, custSelectedAmt)
                return custSelectedAmt;
            }
        }
        if (minAmt < 5000) {
            minAmt = 5000;
        }
        return getRoundedMinimumValue(minAmt);
    }

    const getMaxOwnDeclaredAmt = () => {
        let maxAmt = 60000;
        let minTruck = 1;
        maxAmt = (data[1]?.noOfTruckRequire ? data[1]?.noOfTruckRequire : 1) * maxAmt;
        return maxAmt;
    }

    const minAmt = getMinOwnDeclaredAmt();
    const maxOwnAmtAmt = getMaxOwnDeclaredAmt();
    //const [ownValue, setOwnValue] = useState(data[1]?.isWeightDetuctible === true ? minAmt : 0); // default
    const [ownValue, setOwnValue] = useState(data[1]?.isWeightDetuctible === true ?
        customerInfoState?.FVPOption != -1 ? customerInfoState?.CustomerSelected : minAmt : 0);
    const [ownCoverageCost, setOwnCoverageCost] = useState(ownValue * data[1]?.weightDetuctible.multiplier);
    const [errorMsg, setErrorMsg] = useState("");

    useEffect(() => {
        if (!customerInfoState?.customerId) {
            navigate('/');
            return;
        }

        if (customerInfoState.FVPOption == 1 || selectedNo == 1) {
            setSelectedValue(customerInfoState?.CustomerSelected);
            setCoverageCost((customerInfoState?.CustomerSelected / 1000) * currentTarrifRate)
        }

    }, [customerInfoState])

    useEffect(() => {
        setCoverageCost((selectedValue / 1000) * currentTarrifRate)
    }, [selectedValue])

    useEffect(() => {
        setOwnCoverageCost((ownValue * data[1]?.weightDetuctible?.multiplier))
        //validateOwnAmount(ownValue);
    }, [ownValue])

    useEffect(() => {
        setSignCDate(signatures?.getUrl ?
            `SIGNED ${moment(new Date(customerInfoState?.SignedDated)).format('MM/DD/YYYY HH:mm A')}` :
            customerSign ? `SIGNED ${moment(signDate).format('MM/DD/YYYY HH:mm A')}` : "")
    }, [signDate, customerSign, signatures?.getUrl])


    useEffect(() => {
        setSignCDriverDate(signaturesDriver?.getUrl ?
            `SIGNED ${moment(new Date(customerInfoState?.DriverSignedDated)).format('MM/DD/YYYY HH:mm A')}` :
            driverSign ? `SIGNED ${moment(signDriverCDate).format('MM/DD/YYYY HH:mm A')}` : "")
    }, [signDriverCDate, driverSign, signaturesDriver?.getUrl])


    useEffect(() => {
        const element = document.getElementById("option_" + customerInfoState?.FVPOption);
        if (element) {
            element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
    }, [])

    const handleCustomerSignEnd = (evt: any) => {
        //@ts-ignore
        const signatureSize = calculateBase64SignSize(customerSignRef?.current?.getTrimmedCanvas()?.toDataURL());

        if (validateSignatureBySize && (signatureSize <= validSignatureSize)) {
            setInvalidCustomerSignMessage("We couldn't detect a Shipper/Customer signature.");

        } else {
            // @ts-ignore
            setCustomerSign(customerSignRef?.current?.getTrimmedCanvas()?.toDataURL() || "")
            setInvalidCustomerSignMessage("");
        }
        setSignDate(new Date());
    }

    const handleDiverSignEnd = (evt: any) => {
        //@ts-ignore
        const signatureSize = calculateBase64SignSize(driverSignRef?.current?.getTrimmedCanvas()?.toDataURL());

        if (validateSignatureBySize && (signatureSize <= validSignatureSize)) {
            setInvalidDriverSignMessage("We couldn't detect a Carrier/Driver signature.");

        } else {
            // @ts-ignore
            setDriverSign(driverSignRef?.current?.getTrimmedCanvas()?.toDataURL() || "")
            setInvalidDriverSignMessage("");
        }
        setSignDriverCDate(new Date());
    }
    const clearCustomerSignature = async () => {
        setCustomerSign("");
        setInvalidCustomerSignMessage("");
        customerSignRef?.current?.clear();

        dispatch({
            'type': actionTypeConstants.UPDATE_CUSTOMER_INFO,
            'payload': {
                ...customerInfoState, 
                CustomerSelected:selectedValue,
                "Signatureurl": [{
                    "getUrl": "",
                    "putUrl": customerInfoState?.Signatureurl?.[0].putUrl
                }]
            }
        })
    }

    const clearDriverSignature = async () => {
        setDriverSign("");
        setInvalidDriverSignMessage("");
        driverSignRef?.current?.clear();
        dispatch({
            'type': actionTypeConstants.UPDATE_CUSTOMER_INFO,
            'payload': {
                ...customerInfoState, "DriverSignurl": [{
                    "getUrl": "",
                    "putUrl": customerInfoState?.DriverSignurl?.[0].putUrl
                }]
            }
        })
    }
    const Title = ({ title, subtitle }: any) => {
        return <div className="singleTitleBlock">
            <Typography variant='h6' color='textPrimary' className="title" noWrap={false} align='center'>
                <DynamicHtml content={title} />
            </Typography>
            {subtitle && <Typography variant='body2' color='textPrimary' className="sub_title" noWrap={false} align='center'>
                <DynamicHtml content={subtitle} />
            </Typography>}
        </div>
    }

    const handleContinue = () => {
        //navigate(templateProps?.nextScreen || '/');
        if (customerInfoState?.isLocalJourney) {
            //only for testing
            // dispatch({
            //     'type': actionTypeConstants.UPDATE_CUSTOMER_INFO,
            //     'payload': { ...customerInfoState, "FVPOption": selectedNo }
            // })
            // navigate(templateProps?.nextScreen || '/');
            updateSelection(customerInfoState.customerId)
        } else {
            saveFVPValue();
        }
    }

    const saveFVPValue = async () => {
        setLoading(true);
        let geturl = customerInfoState?.Signatureurl[0].getUrl || "";
        let geturlDriver = customerInfoState?.DriverSignurl[0].getUrl || "";

        if (source != 2) {
            let callSelection = true;
            if (!geturl) {
                await uploadSignature(customerSign, 'customer');
                callSelection = false
            }
            if (!geturlDriver && customerInfoState?.IsDriver == 1) {
                await uploadSignature(driverSign, 'driver');
                callSelection = false
            }
            if (callSelection == true) {
                updateSelection(customerInfoState.customerId)
            }
        } else {
            updateSelection(customerInfoState.customerId)
        }
    }

    const saveFVPValueOrg = async () => {
        setLoading(true);
        let geturl = customerInfoState?.Signatureurl[0].getUrl || "";

        if (!geturl && source != 2) {
            //const respo = await uploadSignature(customerSign);
            //console.log("respo:", respo);
            alert("hi")
        } else {
            alert("hellohi")
            updateSelection(customerInfoState.customerId)
        }
    }

    const updateSelection = async (CID: any) => {

        // const abc = customerInfoState?.IsDeductible ? customerInfoState?.DeductibleAmount : 0;
        const isWeightDetuctible = customerInfoState?.IsWeightDeductible;
        let params = {};
        if (isWeightDetuctible) {
            params = {
                "CustomerId": CID,
                "SelectedOption": selectedNo,
                "SelectedAmmount": (selectedNo == 1 || selectedNo == 3) ? ownValue : 0,
                // "CoverageCost": ownCoverageCost.toFixed(2),
                "CoverageCost": (selectedNo == 1 || selectedNo == 3) ? ownCoverageCost.toFixed(2) : 0, //
                "CustomerSign": customerSign,
                "IsTab": customerInfoState?.IsTab,
                "DeductibleAmount": 0,
                "SignDate": signCDate?.toString().split(" ")[1],
                "SignTime": signCDate?.toString().split(" ")[2] + " " + signCDate?.toString().split(" ")[3],
                "DriverSignDate": customerInfoState?.IsDriver == 1 ? signCDriverDate?.toString().split(" ")[1] : "",
                "DriverSignTime": customerInfoState?.IsDriver == 1 ? signCDriverDate?.toString().split(" ")[2] + " " + signCDriverDate?.toString().split(" ")[3] : "",
            }
        } else {
            params = {
                "CustomerId": CID,
                "SelectedOption": selectedNo,
                "SelectedAmmount": selectedNo == 1 ? selectedValue : 0,
                "CoverageCost": selectedNo == 1 ? ((selectedValue / 1000) * currentTarrifRate) : 0,
                "CustomerSign": customerSign,
                "IsTab": customerInfoState?.IsTab,
                "DeductibleAmount": customerInfoState?.IsDeductible ? customerInfoState?.DeductibleAmount : 0,
                "SignDate": signCDate?.toString().split(" ")[1],
                "SignTime": signCDate?.toString().split(" ")[2] + " " + signCDate?.toString().split(" ")[3],
                "DriverSignDate": customerInfoState?.IsDriver == 1 ? signCDriverDate?.toString().split(" ")[1] : "",
                "DriverSignTime": customerInfoState?.IsDriver == 1 ? signCDriverDate?.toString().split(" ")[2] + " " + signCDriverDate?.toString().split(" ")[3] : "",
            }
        }
        // console.log("saveFVPValue 3option params:", params);

        try {
            const endPoint = `${process.env.REACT_APP_API_ENDPOINT}/saveFVPValue`;
            await fetch(endPoint, {
                method: 'POST',
                headers: {
                    'x-api-key': `${process.env.REACT_APP_FVP_API_KEY_DEV}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(params)
                // body: JSON.stringify({
                //     "CustomerId": CID,
                //     "SelectedOption": selectedNo,
                //     "SelectedAmmount": selectedNo == 1 ? selectedValue : 0,
                //     "CoverageCost": selectedNo == 1 ? ((selectedValue / 1000) * currentTarrifRate) : 0,
                //     "CustomerSign": customerSign,
                //     "IsTab": customerInfoState?.IsTab,
                //     "DeductibleAmount": customerInfoState?.IsDeductible ? customerInfoState?.DeductibleAmount : 0
                // })
            })
                .then(response => response.json())
                .then(async (data) => {
                    // console.log(data);
                    setLoading(false);
                    if (data == true) {
                        await getCustomerDetail(customerInfoState?.customerId);
                        navigate(templateProps?.nextScreen || '/');
                    } else {
                        alert("Data is not saved.");
                    }
                });
        } catch (error) {
            console.error('ERROR:', error);
            setLoading(false);
        }
    }

    const showSignButton = () => {
        if (customerSign && (customerInfoState?.IsDriver == 1 && driverSign)) {
            return true;
        } else if (customerSign && customerInfoState?.IsDriver == 0) {
            return true;
        } else if(customerInfoState?.IsTab != 2){
            return true;
        }else {
            return false
        }

    }

    const CustomerSignBlock = (idx: number) => {
        return <div style={{ paddingTop: 32, clear: "both" }}>
            {customerInfoState?.IsTab != 2 ?
                <div>
                    <SignatureCard
                        title={templateProps?.signCard?.title || ""}
                        signRef={customerSignRef}
                        onEnd={handleCustomerSignEnd}
                        onBegin={() => { setInvalidCustomerSignMessage(""); }}
                        sign={customerSign || ""}
                        populate={signatures?.getUrl ? true : false}
                        handleClearClick={clearCustomerSignature}
                        signHere={templateProps?.signCard?.signHere || `${customerInfoState?.CustomerName} SIGN HERE`}
                        signDate={signCDate}
                    />
                    <div className='color-red fw-500 mb-30 mt-8'>{invalidCustomerSignMessage}</div>

                    {customerInfoState?.IsDriver == 1 && (
                        <>
                            <div style={{ height: 20 }}></div>
                            {
                                customerInfoState?.IsTab != 1 &&
                                <>
                                <SignatureCard
                                title={templateProps?.signCard?.title || ""}
                                signRef={driverSignRef}
                                onEnd={handleDiverSignEnd}
                                onBegin={() => { setInvalidDriverSignMessage(""); }}
                                sign={driverSign || ""}
                                populate={signaturesDriver?.getUrl ? true : false}
                                handleClearClick={clearDriverSignature}
                                signHere={templateProps?.signCard?.signHere || `${customerInfoState?.DriverName} SIGN HERE`}
                                signDate={signCDriverDate}
                            />
                                </>
                            }

                        </>
                    )}
                    <div className='color-red fw-500 mb-30 mt-8'>{invalidDriverSignMessage}</div>
                    <div>
                        {
                            // (customerSign && (customerInfoState?.IsDriver == 1 && driverSign))
                            (showSignButton()) && <Button
                                onClick={handleContinue}
                                color="primary"
                                loading={loading}
                                variant="contained"
                                disabled={loading ||  !customerSign || (selectedNo == 1 && (errorMsg.length == 0 ? false : true))}
                                size="large"
                                text={"CONTINUE"}
                            />
                        }
                    </div>
                </div>
                :
                <div>
                    <Button
                        onClick={handleContinue}
                        color="primary"
                        variant="contained"
                        disabled={loading || (selectedNo == 1 && (errorMsg.length == 0 ? false : true))}
                        size="large"
                        text={"CONTINUE"}
                    />
                </div>
            }
        </div>
    }

    const handleChange = (event: { target: { value: string } }) => {
        // @ts-ignore
        setSelectedValue(event.target.value);
    };

    const handleDeselectOption = (sno: number) => {
        clearCustomerSignature();
        if (selectedNo == sno) {
            SetSelectedNo(-1);
        } else {
            SetSelectedNo(sno);
        }
    }
    function allowChars(charValue: any) {
        const acceptedKeys = '0123456789';
        return acceptedKeys.indexOf(charValue) > -1;
    }
    function handleKeyPress(e: any) {
        const key = e.key;
        const max = maxOwnAmtAmt;
        const min = 7200;
        // console.log("cc:", allowChars(key));
        if (!allowChars(key)) {
            console.log("Not Allowed:", key);
            e.preventDefault();
        } else {
            let val = e.target.value;
            val = val + +key;
            console.log("Allowed:", key, val, ownValue, val > max);
            if (val > max) {
                e.target.value = e.target.value.slice(0, e.target.value.length - 1);

                return;
            }
            setOwnValue(e.target.value)
        }
    }

    const validateOwnAmount = (val: number) => {
        let flag = true;
        if (val > maxOwnAmtAmt) {
            flag = false;
            setErrorMsg(`Value cannot be more than ${maxOwnAmtAmt}`);
        } else if (val < minAmt) {
            flag = false;
            setErrorMsg(`Value cannot be less than ${minAmt}`)
        }
        if (flag == true) {
            setErrorMsg("");
        }
    }
    const handleOwnCoverageCost = (event: any, sno: number) => {
        // let val = event.target.value;
        // let flag = true;
        // if (val > maxOwnAmtAmt) {
        //     flag = false;
        //     setErrorMsg(`Value cannot be more than ${maxOwnAmtAmt}`);
        // } else if (val < minAmt) {
        //     flag = false;
        //     setErrorMsg(`Value cannot be less than ${minAmt}`)
        // }
        // if (flag == true) {
        //     setErrorMsg("");
        // }
        validateOwnAmount(event.target.value);
        if (sno == 1) {
            setOwnValue(event.target.value);
        }
    };



    const renderZeroDetuctibleBlock = ({ dropdown, recommendedInfo }: any) => {
        return <div className="connditionalBlock">
            <div className="conditionalBlockChild">
                <div style={{
                    marginBottom: 8
                }}><Typography variant='caption' color='textPrimary' className="title" noWrap={false} align='center'>
                        <DynamicHtml content={dropdown?.label} />
                    </Typography></div>
                <div>
                    <Select labelId="label" className="selectMenuBlock" value={selectedValue} onChange={(e: any) => handleChange(e)}>
                        {dropdown?.data?.map((dropItem: any, idx: number) => {
                            return <MenuItem key={idx} value={dropItem?.value} style={{
                                display: "flex", justifyContent: "space-between", alignContent: "center"
                            }}>{dropItem?.label} {selectedValue == dropItem?.value && <span className="checkMarkActive" style={{ float: "right", lineHeight: 0.8, color: "rgba(11, 154, 100, 1)" }}><CustomIcon iconName="check" size="small" /></span>}</MenuItem>
                        })}
                    </Select>
                </div>
            </div>
            <div className="conditionalBlockChild">
                <div style={{
                    marginBottom: 8
                }}><Typography variant='caption' color='textPrimary' className="title" noWrap={false} align='center'>
                        <DynamicHtml content={recommendedInfo?.sectionLabel} />
                    </Typography></div>
                <div><Typography variant='h5' color='textPrimary' className="title" noWrap={false} align='center'>
                    <DynamicHtml content={"$" + coverageCost} />
                </Typography></div>
            </div>
        </div>
    }

    const renderDetuctibleBlock = ({ dropdown, recommendedInfo, deductible }: any) => {
        return <div>
            <div className="connditionalBlock">
                <div className="conditionalBlockChild">
                    <div style={{
                        marginBottom: 8
                    }}><Typography variant='caption' color='textPrimary' className="title" noWrap={false} align='center'>
                            <DynamicHtml content={deductible?.deductibleDDLLabel} />
                        </Typography></div>
                    <div>
                        <Select labelId="label" className="selectMenuBlock" value={selectedValue} onChange={(e: any) => handleChange(e)}>
                            {dropdown?.data?.map((dropItem: any, idx: number) => {
                                return <MenuItem key={idx} value={dropItem?.value} style={{
                                    display: "flex", justifyContent: "space-between", alignContent: "center"
                                }}>{dropItem?.label} {selectedValue == dropItem?.value && <span className="checkMarkActive" style={{ float: "right", lineHeight: 0.8, color: "rgba(11, 154, 100, 1)" }}><CustomIcon iconName="check" size="small" /></span>}</MenuItem>
                            })}
                        </Select>
                    </div>
                </div>
                <div className="conditionalBlockChild">
                    <div style={{
                        marginBottom: 8
                    }}><Typography variant='caption' color='textPrimary' className="title" noWrap={false} align='center'>
                            <DynamicHtml content={deductible?.deductibleSectionLabel} />
                        </Typography></div>
                    <div><Typography variant='h5' color='textPrimary' className="title" noWrap={false} align='center'>
                        {/* <DynamicHtml content={"$" + coverageCost} /> */}
                        <DynamicHtml content={"$" + deductible.deductibleAmount} />
                    </Typography></div>

                </div>
            </div>
            <div className="conditionalBlockChild">
                <div style={{
                    marginBottom: 8
                }}><Typography variant='caption' color='textPrimary' className="title" noWrap={false} align='center'>
                        <DynamicHtml content={deductible.deductiblePremiumAmountLabel} />
                    </Typography>
                </div>
                <div className="conditionalBlockChild">
                    <Typography variant='h5' color='textPrimary' className="title" noWrap={false} align='center'>
                        <DynamicHtml content={"$" + coverageCost} />
                    </Typography>
                </div>

            </div>
        </div>
    }

    const renderWeightDetuctibleBlock = ({ recommendedInfo, weightDetuctible, sno }: any) => {
        return <div>
            <div className="connditionalBlock" style={{ display: 'flex', alignItems: 'start' }}>
                <div className="conditionalBlockChildWeight">
                    <div style={{
                        marginBottom: 8,
                        textAlign: 'left'
                    }}><Typography variant='caption' color='textPrimary' className="title" noWrap={false} >
                            <DynamicHtml content={weightDetuctible?.weightLabel} />
                        </Typography>
                        <Typography variant='caption' color='textPrimary' className="title" noWrap={false} style={{ fontSize: '10px' }} >
                            <DynamicHtml content={weightDetuctible?.weightSubLabel} />
                        </Typography>
                    </div>
                    <div>
                        <TextField className="inputStyle" variant="outlined" defaultValue={weightDetuctible?.actualWeight + " lbs"} multiline={false} disabled={true} />
                    </div>
                </div>
                <div className="conditionalBlockChildWeight">
                    <div style={{
                        marginBottom: 8
                    }}><Typography variant='caption' color='textPrimary' className="title" noWrap={false} align='center'>
                            <DynamicHtml content={weightDetuctible?.weightCoverageLabel} />
                        </Typography>
                        <Typography variant='caption' color='textPrimary' className="title" noWrap={false} style={{ fontSize: '10px' }} >
                            <DynamicHtml content={"&nbsp;"} />
                        </Typography>
                    </div>
                    <div><Typography variant='h5' color='textPrimary' className="amountSection" noWrap={false} align='center'>
                        <DynamicHtml content={"$" + weightDetuctible.weightCoverageCost} />
                    </Typography></div>

                </div>
            </div>
            <fieldset className="fieldSetStyle">
                <legend>OR</legend>
            </fieldset>
            <div className="connditionalBlock">
                <div className="conditionalBlockChildWeight">
                    <div style={{
                        marginBottom: 8, textAlign: 'left'
                    }}><Typography variant='caption' color='textPrimary' className="title" noWrap={false} >
                            <DynamicHtml content={weightDetuctible?.ownValueLabel} />
                        </Typography></div>
                    <div>
                        <TextField name={`ownValue${sno}`}
                            className="inputStyle" variant="outlined" defaultValue={ownValue} multiline={false}
                            type="number"
                            onChange={(e) => handleOwnCoverageCost(e, sno)}
                        />
                        <span className="errorMessage">{errorMsg}</span>
                        {/* //onKeyPress={handleKeyPress} */}
                        {/* <MaskedTextField type="number" defaultValue={ownValue} isMask={true} maskChar={99999}
                            multiline={false}
                            //onChange={handleOwnCoverageCost}
                            onKeyPress={handleKeyPress}
                            InputProps={{ inputProps: { min: data[1]?.weightDetuctible.actualWeight * data[1]?.weightDetuctible.rate, max: 60000, step: 1 } }} />
                     */}
                    </div>
                </div>
                <div className="conditionalBlockChildWeight">
                    <div style={{
                        marginBottom: 8
                    }}><Typography variant='caption' color='textPrimary' className="title" noWrap={false} align='center'>
                            <DynamicHtml content={weightDetuctible?.coverageCostLabel} />
                        </Typography></div>
                    <div><Typography variant='h5' color='textPrimary' className="amountSection" noWrap={false} align='center'>
                        <DynamicHtml content={"$" + ownCoverageCost.toFixed(2)} />
                    </Typography></div>
                </div>
            </div>
        </div>
    }

    function dataURItoBlob(dataURI: any) {
        var binary = atob(dataURI.split(',')[1]);
        var array = [];
        for (var i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], { type: 'image/png' });
    }

    const uploadSignature = async (userSign: any, signType: string) => {
        try {
            let imageURL = userSign; //signType=='customer'?customerSign: driverSign;
            const blob = dataURItoBlob(imageURL)
            var signature = new File([blob], "");
            const requestOptions: any = {
                method: "PUT",
                body: signature,
                redirect: "follow",
            };

            //const custInfo: any = JSON.parse(localStorage.getItem('customerInfo') || "");
            // let geturl = custInfo?.Signatureurl[0].getUrl || "";
            // let endPoint: any = custInfo?.Signatureurl[0].putUrl || "";

            let geturl = signType == 'customer' ? (customerInfoState?.Signatureurl[0].getUrl || "") : (customerInfoState?.DriverSignurl[0].getUrl || "");
            let endPoint = signType == 'customer' ? (customerInfoState?.Signatureurl[0].putUrl || "") : (customerInfoState?.DriverSignurl[0].putUrl || "");
            //let endPoint: any = customerInfoState?.Signatureurl[0].putUrl || "";

            if (!endPoint) {
                setLoading(false);
                return false
            }

            //let endPoint: any = "https://bol-application-dev.s3.amazonaws.com/signatures/7054279/FVP?AWSAccessKeyId=AKIA437WX7QEP6ZIFKZJ&Expires=1682688600&Signature=fURvEqWdSgJgqjJ3RC5BYMbs5i0%3D";
            return uploadSignatureWithRetry(endPoint, requestOptions, 1);

        } catch (e) {
            console.log(e);
            setLoading(false);
        }
        return false
    }

    const uploadSignatureWithRetry: any = async (endPoint: any, requestOptions: any, noOfRetries: number) => {
        const retryLimit = noOfRetries + 1;

        return await fetch(endPoint, requestOptions)
            .then(async (response: any) => {
                // console.log("response:", response)
                if (response?.ok) {
                    updateSelection(customerInfoState?.customerId)
                } else {
                    console.log("upload failed. so retrying again");
                    if (retryLimit <= 3) {
                        return uploadSignatureWithRetry(endPoint, requestOptions, retryLimit);
                    } else {
                        console.log("Max Retries limit for upload is reached");
                    }
                }
                setLoading(false);
                return response;
            })
    }

    const getCustomerDetail = async (CID: any) => {
        try {
            setLoading(true);
            const endPoint = `${process.env.REACT_APP_API_ENDPOINT}/getCustomerDetails`;
            await fetch(endPoint, {
                method: 'POST',
                headers: {
                    'x-api-key': `${process.env.REACT_APP_FVP_API_KEY_DEV}`,    
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "CustomerId": CID,
                    "source": parseInt(source)
                })
            })
                .then(response => response.json())
                .then((data) => {   
                    localStorage.setItem("customerInfo", JSON.stringify(data));
                    dispatch({
                        'type': actionTypeConstants.UPDATE_CUSTOMER_INFO,
                        'payload': { ...data, "customerId": localStorage.getItem('CID')}
                    })
                    setLoading(false);
                });
        } catch (error) {
            console.error('ERROR:', error);
            setLoading(false);
        }
    }
    // console.log("MovingProtection customerInfoState:", customerInfoState);

    const renderAMSProtectionPlan = (item: any) => {

        if (item?.sno == 1 || item?.sno == 3) {
            if (item.isDeductible) {
                return renderDetuctibleBlock(item)
            } else if (item.isWeightDetuctible) {
                return renderWeightDetuctibleBlock(item)
            } else {
                return renderZeroDetuctibleBlock(item)
            }
        }
    }


    // console.log("selectedNo:", selectedNo);
    return (<div className='full-block movingProtection'>
        {/* <Header backNav={true} progressValue={0} /> */}
        <div className="outlineContainer">
            <div className="baseContainerBlock">
                <div><TitleBlock title={title} subtitle={subtitle} /></div>
                <div>
                    {data?.map((item: any, idx: number) => {

                        return item?.content?.length > 0 && <div key={idx} id={"option_" + item?.sno} className={item?.isRecommended ? "protectionRec" : ""} style={{
                            width: "100%", float: "left"
                        }}>
                            <Cards variant="default">
                                {item?.isRecommended && <Typography variant="overline" variantMapping={{ subtitle2: "span" }} className="protectTag">
                                    {"Recommended"}
                                </Typography>}
                                <div>
                                    <Title title={item?.title} subtitle={item?.subtitle || ""} />
                                </div>
                                {item?.isRecommended && <div style={{
                                    paddingTop: 8, paddingBottom: 16, clear: "both"
                                }}><Typography variant="subtitle2" variantMapping={{ subtitle2: "span" }} className="popularOption">
                                        {item?.recommendedInfo?.highlightInfo}
                                    </Typography></div>}
                                <div>
                                    <Typography color='textPrimary' noWrap={false} align='center' className="protectionContent">
                                        {
                                            item.sno == 2 && selectedNo == 2 ?
                                                <DynamicHtml content={item?.selectedContent} />
                                                : <DynamicHtml content={item?.content} />
                                        }

                                    </Typography>
                                </div>
                                <div>
                                    {
                                        renderAMSProtectionPlan(item)
                                    }
                                </div>

                                <div className='selectBtnCn protectionBtnCntnr'>
                                    <div>
                                        <Typography variant='caption' color='textPrimary' className="title" noWrap={false} align='center'>
                                            <DynamicHtml content={item?.recommendedInfo?.footer} />
                                        </Typography>
                                    </div>
                                    <div style={{
                                        textAlign: "right"
                                    }}>
                                        <Button
                                            onClick={() => handleDeselectOption(item?.sno)}
                                            color="primary"
                                            variant="outlined"
                                            endIcon={selectedNo == item?.sno ? "check" : ""}
                                            text={selectedNo == item?.sno ? "SELECTED" : "SELECT"}
                                        >
                                        </Button>
                                    </div>
                                </div>

                                {selectedNo == item?.sno && CustomerSignBlock(item?.sno)}
                            </Cards>
                        </div>
                    })}
                </div>
            </div>
        </div>
    </div>)
}

export default MovingProtection